import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_ALERTS = createActionTypes('FETCH_ALERTS');
export const DOWNLOAD_ALERTS = createActionTypes('DOWNLOAD_ALERTS');

